import Vue from 'vue'
import VueGtm from 'vue-gtm'

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM,
  enabled: process.env.VUE_APP_ENV == 'production',
})
